import { useEffect, useRef, useState } from "react";
import Select from "../../../../../../components/Select";
import GenericSwitch from "../../../../../../components/GenericSwitch";
import { getCamposEquipamento } from "../../../../../../services/equipamentos";
import helper from "../../../../../../utils/helper";

const DefaultParamsRow = ({ param, data, equipmentList, error, onChange }) => {
    const fieldsCache = useRef({});
    const [fields, setFields] = useState([]);

    useEffect(() => {
        const loadFields = async () => {
            if (!data.equipment) {
                setFields([]);
                return;
            }

            if (!fieldsCache.current[data.equipment]) {
                fieldsCache.current[data.equipment] = await getCamposEquipamento(data.equipment);
            }

            setFields(fieldsCache.current[data.equipment]);
        };

        loadFields();
    }, [data.equipment]);

    const handleChange = (field, value) => {
        if (field === "equipmentField") {
            if (
                param.recommendedSpecialOperator &&
                param.recommendedSpecialOperator !== value?.special_operator
            ) {
                helper.dispatchEvent("showAviso", { message: param.wrongParamOperatorMessage });
            }
        }

        onChange(param.key, field, field === "equipmentField" ? value?.value : value);
    };

    return (
        <div className="grant-default-params__wrapper">
            <div className="grant-default-params__label">
                <GenericSwitch
                    checked={data.isActive}
                    onChange={value => onChange(param.key, "isActive", value)}
                />
                <strong>{param.label}</strong>
            </div>

            <div className={`grant-default-params__row ${(!param.extraFieldName || !param.extraOptions) ? "no-extra" : ""}`}>
                <div className="grant-default-params__select">
                    <label>Equipamento</label>
                    <Select
                        value={data.equipment}
                        options={equipmentList}
                        placeholder="Equipamento"
                        disabled={!data.isActive}
                        onChange={option => onChange(param.key, "equipment", option.value)}
                        hasError={error?.equipment}
                        resolveValueFromOptions
                    />
                </div>

                <div className="grant-default-params__select">
                    <label>Parâmetro</label>
                    <Select
                        value={data.equipmentField}
                        options={fields}
                        placeholder="Parâmetro"
                        disabled={!data.isActive}
                        onChange={option => handleChange("equipmentField", option)}
                        hasError={error?.equipmentField}
                        resolveValueFromOptions
                    />
                </div>

                {param.extraFieldName && param.extraOptions && (
                    <div className="grant-default-params__extra">
                        <label>{param.extraFieldLabel}</label>
                        <Select
                            value={data[param.extraFieldName]}
                            options={param.extraOptions}
                            placeholder="Tipo"
                            disabled={!data.isActive}
                            onChange={option => onChange(param.key, param.extraFieldName, option.value)}
                            resolveValueFromOptions
                        />
                    </div>
                )}

                <div className="grant-default-params__inputs__wrapper">
                    <div className="grant-default-params__inputs__wrapper-input">
                        <label>Alerta (Início)</label>
                        <input
                            type="number"
                            value={data.alertValueStart}
                            disabled={!data.isActive}
                            onChange={e => onChange(param.key, "alertValueStart", e.target.value)}
                            className={error?.alertValueStart ? "has-error" : ""}
                        />
                    </div>
                    <i className="fa fa-arrow-right" />
                    <div className="grant-default-params__inputs__wrapper-input">
                        <label>Alerta (Fim)</label>
                        <input
                            type="number"
                            value={data.alertValueEnd}
                            disabled={!data.isActive}
                            onChange={e => onChange(param.key, "alertValueEnd", e.target.value)}
                            className={error?.alertValueEnd ? "has-error" : ""}
                        />
                    </div>
                </div>

                <div className="grant-default-params__inputs__wrapper">
                    <div className="grant-default-params__inputs__wrapper-input">
                        <label>Crítico (Início)</label>
                        <input
                            type="number"
                            value={data.criticalValueStart}
                            disabled={!data.isActive}
                            onChange={e => onChange(param.key, "criticalValueStart", e.target.value)}
                            className={error?.criticalValueStart ? "has-error" : ""}
                        />
                    </div>
                    <i className="fa fa-arrow-right" />
                    <div className="grant-default-params__inputs__wrapper-input">
                        <label>Crítico (Fim)</label>
                        <input
                            type="number"
                            value={data.criticalValueEnd}
                            disabled={!data.isActive}
                            onChange={e => onChange(param.key, "criticalValueEnd", e.target.value)}
                            className={error?.criticalValueEnd ? "has-error" : ""}
                        />
                    </div>
                </div>


                <div className="grant-default-params__inputs__wrapper">
                    <div className="grant-default-params__inputs__wrapper-input">
                        <label>Excedido (Início)</label>
                        <input
                            type="number"
                            value={data.exceededValueStart}
                            disabled={!data.isActive}
                            onChange={e => onChange(param.key, "exceededValueStart", e.target.value)}
                            className={error?.exceededValueStart ? "has-error" : ""}
                        />
                    </div>
                    <i className="fa fa-arrow-right" />
                    <div className="grant-default-params__inputs__wrapper-input">
                        <label>Excedido (Fim)</label>
                        <input
                            type="number"
                            value={data.exceededValueEnd}
                            disabled={!data.isActive}
                            onChange={e => onChange(param.key, "exceededValueEnd", e.target.value)}
                            className={error?.exceededValueEnd ? "has-error" : ""}
                        />
                    </div>
                </div>
            </div>
        </div>
    );
};

export default DefaultParamsRow;